import React from 'react';

const ToolbarButton = ({ onClick, children, isActive = false, variant = "default", startIcon, endIcon }) => {
  const baseClasses = "inline-flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200";
  const variantClasses = variant === "contained" 
    ? "bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-indigo-500"
    : isActive
    ? "bg-indigo-100 text-indigo-700 hover:bg-indigo-200"
    : "text-gray-700 hover:bg-gray-100 focus:ring-gray-500";
  
  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${variantClasses}`}
    >
      {startIcon && <span className={children ? "mr-2" : ""}>{startIcon}</span>}
      {children}
      {endIcon && <span className={children ? "ml-2" : ""}>{endIcon}</span>}
    </button>
  );
};

export default ToolbarButton;
